export enum AccessType {
    admin= 'admin',
    restricted = 'restricted'
}
